// extracted by mini-css-extract-plugin
export default {"card":"Card_card__KgzEv","container":"Card_container__TNCmo","modal":"Card_modal__SDVVa"};